var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes }, [
    _vm.illustration
      ? _c("div", { staticClass: "kpi-item__illustration" }, [
          _c("img", {
            staticClass: "kpi-item__illustration-image",
            attrs: { src: _vm.illustration, alt: _vm.label }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "kpi-item__content" }, [
      !_vm.hideTitle
        ? _c(
            "div",
            {
              staticClass:
                "kpi-item__label typographies-paragraph-x-small-regular"
            },
            [_vm._v("\n            " + _vm._s(_vm.label) + "\n        ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "kpi-item__value typographies-paragraph-large-semibold"
        },
        [
          _vm._v("\n            " + _vm._s(_vm.value) + "\n            "),
          _vm.suffix
            ? _c(
                "span",
                {
                  staticClass:
                    "kpi-item__suffix typographies-paragraph-x-small-semibold"
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t.__(_vm.suffix)) +
                      "\n            "
                  )
                ]
              )
            : _vm._e()
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }